import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import detector from 'i18next-browser-languagedetector'

const LANG_STORAGE_KEY = 'dsok_adminui_lang'
const SUPPORTED_LANGS = ['en', 'sk', 'cs', 'de']

i18n
  .use(Backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGS,
    debug: false,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANG_STORAGE_KEY,
      caches: ['localStorage'],
    },
  })
  .then(() => {
    const current = i18n.language ? i18n.language.split('-')[0] : ''
    if (current && !SUPPORTED_LANGS.includes(current)) {
      try {
        localStorage.removeItem(LANG_STORAGE_KEY)
      } catch (_) {}
      i18n.changeLanguage('en')
    }
  })

export default i18n
